import * as ko from 'knockout';

import { BaseForm } from './base_form';
import { MeasurementMetaTag } from '../models/measurement_meta_tag';
import * as mmTagsApi from '../api/measurement_meta_tags';
import { Deferred } from '../utils/deferred';
import { asI18nText } from '../i18n_text';
import { createWithComponent } from '../utils/ko_utils';
import { canEditTraitTags } from '../permissions';

const template = require('raw-loader!../../templates/measurement_meta_tag_edit.html').default;

class MeasurementMetaTagEditEditScreen extends BaseForm<mmTagsApi.MeasurementMetaTagData> {
  entity = ko.validatedObservable<MeasurementMetaTag>(null);
  canEdit = canEditTraitTags();

  constructor(
    params: {
      id: string;
      initialName?: string;
      result?: Deferred<mmTagsApi.MeasurementMetaTagData>;
    },
    componentInfo: KnockoutComponentTypes.ComponentInfo
  ) {
    super(params);

    let promise = Promise.all([params.id ? mmTagsApi.retrieve(params.id) : undefined]).then(([data]) => {
      this.entity(new MeasurementMetaTag(data));
      if (!data && params.initialName) {
        this.entity().nameJson(asI18nText(params.initialName));
      }
    });
    this.loadedAfter(promise).then(() => this.focusFirst(componentInfo.element));
  }

  save = () => {
    if (this.validateLocal(this.entity)) {
      let data = this.entity().toData();
      this.executeSaveRequest(mmTagsApi.save(data)).then((validation) => {
        this.onRemoteValidation(data, this.entity(), validation);
      });
    }
  };
}

export const measurementMetaTagEdit = {
  name: 'measurement-meta-tag-edit',
  viewModel: createWithComponent(MeasurementMetaTagEditEditScreen),
  template,
};

ko.components.register(measurementMetaTagEdit.name, measurementMetaTagEdit);
